import LogList from '@/components/log/list/LogList.vue'
import TableFilter from '@/components/common/tablefilter/TableFilter.vue'

const defaultFilterValues = {
  type: null,
  client: null,
  date: null
};
export default {
  name: 'UserLog',
  components: {
    LogList,
    TableFilter
  },
  data () {
    return {
      isMounted: false,
      filterValues: {
        type: null,
        user: null,
        modifiedUser: null,
        date: null,
        datefrom: null,
        dateto: null
      }
    }
  },
  computed: {
    logReqPath () {
      return 'user/log';
    },
    logItemName () {
      return 'users'
    },
    logTitle () {
      return '';
    },
    logRecordTypeOptions () {
      let options = this.$store.getters.getConfigOptions('log_record_types', this.$i18n.locale);
      options = options.filter(el => (el.code.indexOf('USER-') === 0));
      options.unshift({ code: null, text: '' });
      return options;
    },
    tableFilterConfig () {
      const filters = {};
      filters.type = { type: 'select', label: this.$t('log.filters.type'), options: this.logRecordTypeOptions, colOnlyFilter: true };
      filters.user = { type: 'userpicker', label: this.$t('log.user'), colOnlyFilter: true };
      filters.date = { type: 'date', label: this.$t('general.filters.date'), colOnlyFilter: true, short: true };
      filters.datefrom = { type: 'date', label: this.$t('general.filters.datefrom') };
      filters.dateto = { type: 'date', label: this.$t('general.filters.dateto') };
      filters.modifiedUser = { type: 'userpicker', label: this.$t('log.users.modified_user'), colOnlyFilter: true };
      return filters;
    }
  },
  methods: {
    filterChanged (key, val) {
      this.filterValues[key] = val;
      this.BasicHelper.updateFilterValues(this.$route.name, this.filterValues);
    },
    clearFilters () {
      this.filterValues = this.BasicHelper.cloneObject(defaultFilterValues);
      this.loadLog();
    },
    loadLog () {
      this.$refs.logList.changePage(1);
    }
  },
  mounted () {
    this.filterValues = this.BasicHelper.fillFilterValues(this.$route.name, this.filterValues, this.$session);
    this.isMounted = true;
  }
}
